import React from "react";
import { TrophyIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

interface RelatedRappersProps {
  rappers: Array<{
    id: string;
    slug: string;
    name: string;
    imagePath: string | null;
    communityRank: number | null;
  }>;
}

const RelatedRappers: React.FC<RelatedRappersProps> = ({ rappers }) => {
  const navigate = useNavigate();

  const handleRapperClick = (slug: string) => {
    navigate(`/rapper/${slug}`);
  };

  if (rappers.length === 0) {
    return null;
  }

  return (
    <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700">
      <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
        <TrophyIcon className="w-6 h-6 text-blue-500" />
        Related Rappers
      </h3>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
        {rappers.map((rapper) => (
          <div
            key={rapper.id}
            onClick={() => handleRapperClick(rapper.slug)}
            className="bg-gray-700/50 rounded-lg p-4 text-center hover:bg-gray-700 transition-colors cursor-pointer group"
          >
            {/* Rapper Image */}
            <div className="w-28 h-28 mx-auto mb-3 rounded-full overflow-hidden bg-gray-600">
              {rapper.imagePath ? (
                <img
                  src={rapper.imagePath}
                  alt={rapper.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400">
                  <TrophyIcon className="w-8 h-8" />
                </div>
              )}
            </div>

            {/* Rapper Name */}
            <h4 className="text-white font-medium mb-1 group-hover:text-blue-400 transition-colors text-sm">
              {rapper.name}
            </h4>

            {/* Community Rank */}
            {rapper.communityRank && (
              <div className="text-yellow-500 text-xs font-medium">
                #{rapper.communityRank}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* View More Button */}
      {/* {rappers.length >= 6 && (
        <div className="text-center mt-6">
          <button className="text-blue-400 hover:text-blue-300 text-sm font-medium hover:underline">
            Explore More Rappers →
          </button>
        </div>
      )} */}
    </div>
  );
};

export default RelatedRappers;
